import { graphql } from 'gatsby';
import { applyPaddingCSS } from '@/utils/generatePadding';
import StatBlock from './components/StatBlock';
import type { BlockHTMLId } from '@/utils/renderBlock';
import {
  StyledComponentWrapper,
  StyledStatBarBlockV2,
  StyledHeadline,
  StyledBody,
  StyledHeader,
  StyledStatBlocksContainer,
} from './StatBarBlockV2.styles';

const StatBarBlockV2 = ({
  elements,
  system,
  id,
}: Queries.STATBAR_BLOCK_V2Fragment & BlockHTMLId) => {
  const { layout, headline, body, stat_blocks, options } = elements;
  const blockCount = stat_blocks?.value.length ?? 0;

  return (
    <StyledComponentWrapper css={applyPaddingCSS(elements)} data-codename={system.codename} id={id}>
      <StyledStatBarBlockV2 layout={layout?.value ?? 'right'}>
        <StyledHeader>
          <StyledHeadline>{headline?.value}</StyledHeadline>
          <StyledBody>{body?.value}</StyledBody>
        </StyledHeader>
        <StyledStatBlocksContainer layout={layout?.value ?? 'right'} blockCount={blockCount}>
          {stat_blocks?.value.map((statBlock) => (
            <StatBlock
              key={statBlock.system.id}
              {...statBlock}
              animate={options?.value?.includes('animate_numbers')}
            />
          ))}
        </StyledStatBlocksContainer>
      </StyledStatBarBlockV2>
    </StyledComponentWrapper>
  );
};

export default StatBarBlockV2;

export const fragment = graphql`
  fragment STATBAR_BLOCK_V2 on kontent_item_statbar_block_v2 {
    system {
      codename
      id
      type
    }
    elements {
      ...COMPONENT_A_B_TEST
      ...COMPONENT_PERSONALIZATION
      ...PADDING
      layout {
        value
      }
      options {
        value
      }
      headline {
        value
      }
      body {
        value
      }
      stat_blocks {
        value {
          ...STAT_BLOCK
        }
      }
    }
  }
`;
